<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @titleClick='onItemClick'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <CoilComponent ref='refCoilComponent' v-if="selectedIndex === 0"/>
    <PurchaseComponent ref='refPurchaseComponent' v-if="selectedIndex === 1" :material-type="materialType"/>
    <PurchaseComponent ref='refPurchaseComponent' v-if="selectedIndex === 2"/>
    <ProductComponent ref='refProductComponent' v-if="selectedIndex === 3" />
    <SemiProductComponent ref='refSemiProductComponent' v-if="selectedIndex > 3 && selectedIndex  < 6" />
    <ProductAllComponent ref='refProductAllComponent' v-if='selectedIndex === 6'/>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import CoilComponent from './CoilComponent'
import PurchaseComponent from './PurchaseComponent'
import ProductComponent from './ProductComponent'
import SemiProductComponent from './SemiProductComponent'
import ProductAllComponent from './ProductAllComponent'

export default {
  name: 'bom-tab',
  data: function () {
    return {
      selectedIndex: 0,
      displayPurchase: 'block',
      displayProduct: 'none',
      selectedCode: 'ALL',
      tabs: [
        {
          title: '원자재',
          code: ConstDef.구매품,
          자재유형: ConstDef.자재유형_원자재
        },
        {
          title: 'H/W 구매품',
          code: ConstDef.구매품
        },
        {
          title: '외주구매품',
          code: ConstDef.구매품
        },
        {
          title: '완제품',
          code: ConstDef.완제품
        },
        {
          title: '용접반제품',
          code: ConstDef.반제품
        },
        {
          title: '프레스반제품',
          code: ConstDef.다공정품
        },
        {
          title: '전체',
          code: 'ALL'
        }
      ],
      materialType: ConstDef.부자재,
      isVisible: null
    }
  },
  components: {
    DxTabPanel,
    CoilComponent,
    PurchaseComponent,
    ProductComponent,
    ProductAllComponent,
    SemiProductComponent
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    if (this.$route.query.type === 'product') {
      this.selectedIndex = 0
    }
    if (this.$route.query.from === 'sales') {
      // this.isVisible
    }
    const topMenuTab = this.$store.getters.getTopMenuTabByUrl(this.$route.path)
    if (topMenuTab !== null) {
      const tabNameArray = topMenuTab.multiTabName.split('/')
      for (let i = 0; i < tabNameArray.length; i++) {
        this.tabs[i].title = tabNameArray[i]
      }
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onItemClick (e) {
      if (this.tabs[e.itemIndex].code === 'ALL') {
        return
      }
      this.selectedCode = this.tabs[e.itemIndex].code
      if (this.selectedCode === ConstDef.완제품) {
        return
      }
      if (this.selectedCode === ConstDef.구매품 && this.tabs[e.itemIndex].자재유형 !== ConstDef.자재유형_원자재) {
        this.$refs.refPurchaseComponent.refreshProduct(this.selectedCode)
        return
      }
      this.$refs.refSemiProductComponent.refreshProduct(this.selectedCode)
    }
  }
}
</script>

<style lang="scss">
  .purchaseActive {
    display: none;
  }
  .productActive {
    display: none;
  }

</style>
